const path = "/pedagogico/avaliacao-institucional";
export default {
  validarUsuario: `${path}/validar`,
  questionariosServidores: `${path}/questionarios-servidores`,
  instituicaoHabilitadas: (id_processo) => `${path}/instituicao-habilitada/${id_processo}`,
  responderAdministrativo: `${path}/responder-administrativo`,
  respondidasAdministrativo: (id) => `${path}/respondidas-administrativo/${id}`,
  analiseAvaliacaoResponsavel: `${path}/analise-anvaliacao-familia`,
  andamentoAvaliacaoFamilia: `${path}/andamento-familia`,
  devolutiva: `${path}/devolutiva`,
  removePdefDevolutiva: (ano, instituicao, arquivo) =>
    `${path}/devolutiva/${ano}/${encodeURIComponent(instituicao)}/${encodeURIComponent(arquivo)}`,
  devolutivaDiretorio: (ano) => `${path}/devolutiva/${ano}`,
  devolutivaArquivos: (ano, instituicao) => `${path}/devolutiva/${ano}/${encodeURIComponent(instituicao)}`,
  devolutivaDownload: (ano, instituicao, arquivo) =>
    `${path}/devolutiva/${ano}/${encodeURIComponent(instituicao)}/${encodeURIComponent(arquivo)}`,
  relatorioNotaFinal: (id_processo) => `${path}/relatorio-nota-final/${id_processo}`,
};
